module.exports = __webpack_public_path__ + "img/creativo-majuscules.09b9e34b.jpg";